module.exports = __webpack_public_path__ + "img/SMS.29eb253c.svg";